function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 17,
    viewBox: "0 0 28 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.00858 2C9.00858 2.96948 8.71411 3.72002 9.85904 3.72002C10.7113 3.72002 10.0357 2.51437 9.52459 2.344",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2275 2.14917C18.2275 2.74324 17.9945 3.92337 18.9155 3.86919C19.7012 3.82297 19.4963 2.45579 19.0875 2.14917",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4.87985C2.07408 6.80599 2.78298 8.737 3.59341 10.4638C5.16787 13.8187 8.16944 15.2012 11.772 15.371C14.6734 15.5077 17.725 15.1305 20.2467 13.5802C22.719 12.0602 24.4511 9.64994 25.4922 6.9809C26.058 5.53067 26.3665 3.90352 26.3665 2.34167",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 3,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.a7f30aad5df5483f64fe5e214e88ca83.svg";
export { ForwardRef as ReactComponent };